import { render } from "./AddProductForm.vue?vue&type=template&id=a6495d2a"
import script from "./AddProductForm.vue?vue&type=script&lang=js"
export * from "./AddProductForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__